import { assign } from 'xstate'
import { handleSetOptions, handleSetSelectedPrice, loadOptions, buildOrderJourneyUrl, handleDiscount } from './helpers'

export const buildOptions = assign({
  options: loadOptions,
})

export const setOptions = assign({
  options: handleSetOptions,
})

export const setSelectedPrice = assign({
  selectedPrice: handleSetSelectedPrice,
})

export const setOrderUrl = assign({
  orderJourneyUrl: buildOrderJourneyUrl,
})

export const calculateDiscount = assign({
  discount: (ctx) => handleDiscount(ctx),
})
